import { Component, Input, OnInit } from '@angular/core';
import { ViewChild, ElementRef } from '@angular/core';
import { NgForm } from '@angular/forms';
import { FormComponent } from '../../../../../models/FormComponent';
import { Product } from '../../../../../models/Product';
import { ProductValidatorService, Validation, ValidationErrorSettings, ValidationAlertSettings, ValidateAlertFunction } from "../../../../../services/validators/product-validator.service";
import * as $ from 'jquery';

@Component({
  selector: 'app-ape-price',
  templateUrl: './ape-price.component.html',
  styleUrls: ['./ape-price.component.scss']
})
export class ApePriceComponent extends FormComponent implements OnInit {
  @Input('product') product: Product; //assigned a COPY so that original is maintained to check diff.
  @ViewChild('formElement') formElement:ElementRef;
  @ViewChild('formData') formData:NgForm;
  get fieldId():string { return '#'+this.formData.name }
  get fieldValue():string { return this.formData.value as string }

  constructor(
    private _productValidator:ProductValidatorService
  ) { super() }

  ngOnInit() {
    //setting validationAlertSettings will activate alerts
    let validationErrorSettings:ValidationErrorSettings = {fieldNameForMessage:'Price', required:true, minlength:1, numericOnly:true};
    let validateAlertFunction = this._productValidator.validateForPriceAlert;
    let validationAlertSettings:ValidationAlertSettings = {fieldNameForMessage:'Price', required:false, validateAlertFunction:validateAlertFunction }
    this.initParent(this.product, this.formElement, this.formData, this._productValidator, validationErrorSettings, validationAlertSettings);
  }

  // not used - moved logic down to validator so that alert doesn't show as an issue.
  // because 'active' should not be able to toggle the 'required' feature of the alertValidation for price.
  // 
  //callback issued by superclass validation method upon alertView being shown.
  protected alertCallback(result:Validation){
    // console.log('alertCallback overloaded by ape-price, with result', result);
    //alert is not required.  We want to hide it when product is not active.
    //TODO:  *thus, toggling the active switch shall require 'validation' to occur again
    if (!this.product.active){ this.hideAlertView() } 
  }

  //newprice.tofixed changes it from number to string
  //+newprice changes it from string back to a number
  updownclicked($e){
    console.log('updownclicked with event', $e);
    let e0 = $e.path[0];
    let e1 = $e.path[1];
    let isUpward = $(e0).hasClass('upward') || $(e1).hasClass('upward');
    if (isUpward){
      //upward = increase value by $1
      let newprice = +(this.product.product_price + 1).toFixed(2);
      this.product.product_price = newprice;
    } else {
      //downward = reduce value by $1
      let newprice = +(this.product.product_price - 1).toFixed(2);
      if(newprice >= 0){
        //only change price if positive 
        this.product.product_price = newprice;
      }
      
    }
    // console.log('new price', this.product.product_price);
    console.log('---');
    // this.formpatchValue({value:0});
    console.log(this.fieldValue);
    console.log(this.product.product_price)
    console.log('---');
    
    if(this.formData.untouched){
      //'touch' the form by focus and blur on the input field
      //  so that alerts/error divs will show
      this.formElement.nativeElement.focus();
      this.formElement.nativeElement.blur();
    }
    //validate form for alerts/errors
    this.onFormChange(this.product.product_price);
    // this.onFormChange(this.fieldValue);
  }

}


//===================
//UNUSED CODE

// onFormBlur($e){
//   // console.log('blur.$e', $e);
//   let fieldValue = $e.target.value as string;
//   this.onFormChange(fieldValue);
// }

// //TODO: consider grabbing value from this.form
// onFormChange($e){
//   let fieldId = '#'+this.form.name;  //eg, 'apeSku'
//   let fieldValue = $e as string;
//   console.log('this.form.value', this.form.value);
//   console.log('fieldValue', fieldValue);

//   //Validate field value
//   let fieldNameForMessage = 'Price', required=true, minlength=1, numericOnly=true;
//   let result = this.validator.fieldValidator(fieldId, fieldValue, fieldNameForMessage, required, minlength, numericOnly);

//   // Form errors, only show after initial blur
//   let errorElementId = fieldId+'Error';
//   if(this.form.touched && result.success == false){
//     $(errorElementId).html(result.message);
//     $(errorElementId).show();
//   } else {
//     $(errorElementId).hide();
//   }

//   // sku availability (or hide if invalid sku)
//   let alertElementId = fieldId+'Alert';
//   if(result.success == false){
//     $(alertElementId).hide();
//   } else {
//     //fieldValue is valid.  proceed with alertCheck
//     $(alertElementId).show();
//     this.checkPriceAlert(fieldValue, alertElementId);
//   }

// }


// checkPriceAlert(priceValue, alertElementId){
//   //show alert for sku: 'available' or 'taken
//   // console.log('priceValue', priceValue);
//   if(priceValue <=0){
//     $(alertElementId).removeClass( "alert-success" ).addClass( "alert-danger" );
//     $(alertElementId).html('Price is too low');
//   }
//   else if(priceValue > 100){
//     $(alertElementId).removeClass( "alert-success" ).addClass( "alert-danger" );
//     $(alertElementId).html('Price is very high');
//   }
//   else {
//     $(alertElementId).hide();
//   }
// }

// //newprice.tofixed changes it from number to string
// //+newprice changes it from string back to a number
// updownclicked($e){
//   // console.log('updownclicked with event', $event);
//   let e0 = $e.path[0];
//   let e1 = $e.path[1];
//   let isUpward = $(e0).hasClass('upward') || $(e1).hasClass('upward');
//   if (isUpward){
//     //upward = increase value by $1
//     let newprice = +(this.product.product_price + 1).toFixed(2);
//     this.product.product_price = newprice;
//   } else {
//     //downward = reduce value by $1
//     let newprice = +(this.product.product_price - 1).toFixed(2);
//     if(newprice >= 0){
//       //only change price if positive 
//       this.product.product_price = newprice;
//     }
    
//   }
//   // console.log('new price', this.product.product_price);
//   console.log('---');
//   // this.formpatchValue({value:0});
//   console.log(this.form.value);
//   console.log(this.product.product_price)
//   console.log('---');
  
//   if(this.form.untouched){
//     //'touch' the form by focus and blur on the input field
//     //  so that alerts/error divs will show
//     this.formElement.nativeElement.focus();
//     this.formElement.nativeElement.blur();
//   }
//   //validate form for alerts/errors
//   this.onFormChange(this.product.product_price);
// }


// WEBPACK FOOTER //
// ./src/app/components/admin/admin-products/admin-product-edit/ape-price/ape-price.component.ts